import { render, staticRenderFns } from "./UploadStatusList.vue?vue&type=template&id=72130636&scoped=true&"
import script from "./UploadStatusList.vue?vue&type=script&lang=js&"
export * from "./UploadStatusList.vue?vue&type=script&lang=js&"
import style0 from "./UploadStatusList.vue?vue&type=style&index=0&id=72130636&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72130636",
  null
  
)

export default component.exports